import useCommonProps, { BaseComponent } from '../../hooks/useCommonProps';

export enum SvgType {
	TailFin = 'TAILFIN',
	Logo = 'LOGO',
	Check = 'CHECK',
	Bullet = 'BULLET',
	ExtendedTailFin = 'EXTENDEDTAILFIN',
	ExtendedTailFinTall = 'EXTENDEDTAILFINTALL'
}
export interface SvgProps extends BaseComponent {
	type: SvgType
	className?: string
	preserveAspectRatio?: 'none' | 'meet' | 'xMinYMin meet'
}

export const SvgComponent = ({
	type,
	className,
	preserveAspectRatio = 'xMinYMin meet',
	testId = 'svg-component',
	testAttribute,
	testAttributeValue
}: SvgProps) => {
	const validType = type && Object.values(SvgType).indexOf(type) > -1;

	const commonProps = useCommonProps({
		testId,
		testAttribute,
		testAttributeValue: testAttributeValue || testId
	});

	if (!validType) {
		console.error('SvgComponent: Missing or invalid Type');
		return null;
	}

	const RenderSvg = () => {
		switch (type) {
			case SvgType.TailFin:
				return (
					<svg
						{...{ className, preserveAspectRatio }}
						data-svg-type={type}
						role="presentation"
						viewBox="0 0 195 68"
						xmlns="http://www.w3.org/2000/svg"
						{...commonProps}>
						<path d="M0.0151978 68.0003C74.7788 67.9955 108.565 -2.90563 195 0.867072V68.0003H0.0151978Z" />
					</svg>
				);
			case SvgType.Logo:
				return (
					<svg
						{...{ className, preserveAspectRatio }}
						data-svg-type={type}
						role="presentation"
						fill="none"
						height="32"
						viewBox="0 0 47 32"
						width="47"
						xmlns="http://www.w3.org/2000/svg"
						{...commonProps}>
						<g clipRule="evenodd" fillRule="evenodd">
							<path
								d="m46.3 0h-18.9762c-5.8746 0-7.3102.961329-9.6539 3.52698l-16.969949 18.58322c13.553349-.6474 17.731449 12.9742 31.504049 9.2409z"
								fill="#da0530"
							/>
							<path
								d="m39.0454 12.8974c-.1367-.2387-.4912-.3992-1.1179-.1274-.671.2899-.946.4193-.9674.4268-.0189.0039-.8187.4197-.7358-.6619l.2506-2.55107s.1019-.92583-.6268-.92583c0 0-.3852-.03905-1.006.49901 0 0-.3043.2852-.5375.34753-.1347.03314-.2912.04931-.5164-.02761-.2273-.07969-.43-.04221-.59.00394 0 0-.6959.18463-.7477 1.13213l-.2794 2.2655s-.1505.8816-.0715 1.0504c0 0 .0735.3543.7149.1385 0 0 .5437-.1621.6054-1.0895 0 0 .1564-1.8118.4141-2.1649 0 0 .3066-.5779.748-.8244 0 0 .6268-.2991.6181.211l-.2249 2.0785s-.2217 1.0193.2387 1.1822c0 0 .0522.0213-.0636.084 0 0-2.9946 1.2702-6.8514 3.4173.2644-2.183.7169-5.2192.7169-5.2192.0659-.4931-.5394-.4931-.5394-.4931-.5908-.0178-.6722.6718-.7248.9759-.0482.3034-.4935 2.7661-.4935 2.7661-.2039 1.1163-.869 1.0611-.869 1.0611-.6556.0769-.264-1.6923-.264-1.6923.1751-.6359.2367-1.17.7362-1.5972.4888-.4103.5374-.9511.1676-.9649-.6165-.0323-1.2452.6296-1.2452.6296-1.0962 1.0781-1.0922 3.6903-1.0922 3.6903-.0218.828.5398 1.0741.5398 1.0741.6955.3164 1.6514-.2386 1.6514-.2386.2232-.1547.1928.0615.1928.0615l-.0486.6619c-2.829 1.6339-5.9721 3.6702-8.6861 5.9636 0 0-1.2436.9117-.7809 1.5176.4936.6371 1.1796.0568 1.4594-.2044 0 0 2.7804-2.8437 7.9116-6.0303l-.164 2.1397c-.0712.9652-.3814 3.9518-.3814 3.9518-.145 1.1735.0443 1.4035.1099 1.4899.1059.131.5643.5219 1.0788.1886.6346-.4056.3181-1.3823.2161-1.8418-.1055-.4639-.0924-1.2189-.0924-1.2189.0458-.6158.4046-4.7696.4046-4.7696.006-.1633.0269-.3941.0542-.6734 1.9659-1.157 4.2231-2.3281 6.749-3.3987 0 0 1.0914-.4308 2.0216-.7235 0 0 .3067-.1223.6995-.2379.5248-.1507 1.2033-.3854 1.4036-.6757.1154-.1724.1597-.4106.015-.6564zm-7.2633-3.57908s.5793-.48047.3141-.83392c0 0-.2466-.36528-.9326.12308 0 0-.6172.50453-.2406.85758 0 0 .3596.33412.8591-.14674zm-1.6595 6.13838s.6923-.1503.8133-.9353c0 0 .4141-2.9329.4311-3.0323.0182-.099.1972-.8698-.3466-.7511 0 0-.665.127-.7844.785l-.5184 2.8915-.0961.5834s-.1355.6241.5011.4588zm-8.893-2.6745c.5362-.4272.3757-.7842.3757-.7842-.1983-.5704-.9226.0374-.9226.0374-.6129.4343-.4015.862-.4015.862.2699.4627.9484-.1152.9484-.1152zm.6747 2.1925s-.2659 1.9163-.3106 2.3388c0 0-.3568 1.6169.5145 1.325 0 0 .7022-.1925.8113-1.1783l.1399-1.3774s.0438-1.0229.8606-1.4699c0 0 .873-.3909.6086-.9313 0 0-.1652-.4308-.6832-.1984-.3956.1724-.6058.1984-.6058.1984s-.522.0615-.6015.0742c0 0-.6429.0276-.7338 1.2189zm-1.6233-.3255c-.8092.1807-.9151 1.1034-.9151 1.1034l-.4972 3.678c-.0806.731.8674.2008.8674.2008.3912-.23.4588-.712.4588-.712l.1506-.9243.4603-2.4887c.1482-1.0343-.5248-.8572-.5248-.8572zm1.1647-7.35886s.8441-1.55461 1.5107-2.06506c0 0 .7291-.43905.7481-1.16961 0 0 .0561-.47692-.3371-.7846 0 0-1.0274-.83234-1.8616.5917 0 0-3.9339 7.42553-5.2929 14.92293 0 0-.1023.2386-.1292-.4391 0 0-.5781-6.2879-.6014-6.5159-.021-.2268-.0075-.7964-.5335-.8378 0 0-.6192-.1117-.9867.8201l-1.7443 4.2938s-.2892.5341.1771.7388c0 0 .5192.2955.8579-.4319l.8053-1.7231c.1581-.3538.279-.3041.279-.3041.0929.0197.1316.3736.1316.3736s.7089 8.4346.7168 8.5001c.0079.065.0696.7463.6398.7463.4125-.0079.5418-.4663.6244-.8434.0833-.3838.8484-4.4015 2.1299-8.7348.8385-2.8319 1.9177-5.66815 2.8661-7.13796z"
								fill="#fff"
							/>
						</g>
					</svg>
				);
			case SvgType.Check:
				return (
					<svg
						{...{ className, preserveAspectRatio }}
						data-svg-type={type}
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						role="presentation"
						{...commonProps}>
						<path
							d="M20 6.5L9 17.5L4 12.5"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				);
			case SvgType.Bullet:
				return (
					<svg
						{...{ className, preserveAspectRatio }}
						data-svg-type={type}
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						role="presentation"
						{...commonProps}>
						<circle cx="7" cy="7" r="7" fill="currentColor" />
					</svg>
				);
			case SvgType.ExtendedTailFin:
				return (
					<svg
						{...{ className, preserveAspectRatio }}
						data-svg-type={type}
						width="1828"
						height="349"
						viewBox="0 0 1828 349"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						role="presentation">
							<path
							d="M503.538 349L1827.36 349C1757.84 349 1694.38 342.791 1635.66 332.046C1192.52 250.959 1023.83 -94.9349 546.8 25.6399C464.491 46.4447 394.295 84.7426 317.44 145.96C208.87 232.44 137.9 266.75 0.156006 349L503.538 349Z"
							fill="currentColor"
						/>
					</svg>
				);
			case SvgType.ExtendedTailFinTall:
				return (
					<svg
						{...{ className, preserveAspectRatio }}
						data-svg-type={type}
						width="1971"
						height="376"
						viewBox="0 0 1971 376"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						role="presentation">
						<path
							d="M542.901 376L1970.24 376C1895.28 376 1826.87 369.304 1763.55 357.714C1285.76 270.258 1103.87 -102.804 589.546 27.2417C500.801 49.6807 425.115 90.9867 342.251 157.012C225.192 250.285 148.672 287.29 0.156494 376L542.901 376Z"
							fill="currentColor"
						/>
					</svg>
				);
			default:
				return <></>;
		}
	};

	return <RenderSvg />;
};
